export const ProductFilterType = Object.freeze({
  NOT_APPLIED: "no_filter",
  SEARCH: "search",
  CATEGORY: "category",
});
